import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { NumberInput, Radio, SimplePopover } from '@dev/ee-components';
import { CampaignTriggerType } from '@dev/ee-api/ee-api-models';

import { Typography } from '@material-ui/core';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';
import { TimeOptions } from '@/services/dictionaries/ScheduleTimeOptions';
import { getTimeInMinutes } from '@/services/tools/getTimeInMinutes';
import { InputsWrapper, RadioOptionWrapper } from '../../../../../../../../../styled';
import { useCampaignScreensPathsChecker } from '../../../../../../../../../hooks/useCampaignScreensPathsChecker';
import { useGetAutoresponderScheduledInfo } from '../../../../../../../../../hooks/useGetAutoresponderScheduledInfo';

export const SendAfter = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { isImmediately, triggerValue, triggerUnit } = useGetAutoresponderScheduledInfo();

    const [isAfterEvent, setAfterEvent] = useState(!isImmediately);
    const [valueDelay, setValueDelay] = useState(triggerValue);
    const [unitDelay, setUnitDelay] = useState<TimeUnitsEnum>(triggerUnit);

    const changeRadioHandle = (ev): void => {
        const isImmediately = ev.target.value === CampaignTriggerType.SendNow;
        setAfterEvent(!isAfterEvent);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.SendAfterXMinutes', isImmediately ? 0 : getTimeInMinutes(valueDelay, unitDelay));
        dispatch(ModifyCampaignMap(modifyMap));

        isImmediately && setValueDelay(1);
    };
    const changeNumberInputHandle = (e): void => {
        const value = e.target ? e.target.value : e.currentTarget.value;
        setValueDelay(value);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.SendAfterXMinutes', getTimeInMinutes(value, unitDelay));
        dispatch(ModifyCampaignMap(modifyMap));
    };

    const itemClickDropdownHandle = (e, obj: { value: TimeUnitsEnum; label: string }): void => {
        setUnitDelay(obj.value);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.SendAfterXMinutes', getTimeInMinutes(valueDelay, obj.value));
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <RadioOptionWrapper isAutoresponder>
            <Radio
                name="schedule-time-opt"
                gap="4px"
                radios={[
                    {
                        id: 'immediately',
                        label: t('sendimmediately'),
                        value: CampaignTriggerType.SendNow,
                        disabled: isDetailsScreen,
                    },
                    {
                        id: 'afterevent',
                        label: t('send'),
                        value: 'afterEvent',
                        disabled: isDetailsScreen,
                    },
                ]}
                value={isAfterEvent ? 'afterEvent' : CampaignTriggerType.SendNow}
                onChange={changeRadioHandle}
            />
            <InputsWrapper isAutoresponder>
                <NumberInput
                    id="numberinput"
                    name="numberinput"
                    min={1}
                    value={valueDelay}
                    onClickButton={changeNumberInputHandle}
                    onChange={changeNumberInputHandle}
                    disabled={!isAfterEvent || isDetailsScreen}
                />
                <SimplePopover
                    type="input"
                    options={TimeOptions}
                    defaultValue={TimeUnitsEnum.Days}
                    value={unitDelay}
                    minWidth={101}
                    disabled={!isAfterEvent || isDetailsScreen}
                    onItemClick={itemClickDropdownHandle}
                />
                <Typography variant="body1">{t('afterevent')}</Typography>
            </InputsWrapper>
        </RadioOptionWrapper>
    );
};
